/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect, useRef} from 'react';
import {ContentHeader} from '@components';
import {Form} from 'react-bootstrap';
import {toast} from 'react-toastify';
import * as AuthService from '../services/auth';
import {PfButton} from '@profabric/react-components';
import Card from 'react-bootstrap/Card';
import {DateTimePicker} from 'react-tempusdominus-bootstrap';
import Table from './report/Table';

const Smslog = () => {
  const linkedPicker1Ref = useRef();
  const linkedPicker2Ref = useRef();
  const [state, setState] = useState({
    date_start: new Date(),
    date_end: new Date()
  });
  const [isLoading, setLoading] = useState(false);
  const [reportData, setReportData] = useState<any[]>([]);

  const downloadReportWs = async () => {
    setLoading(true);
    try {
      let _date_start = new Date(state.date_start);
      let _date_end = new Date(state.date_end);

      const offset = _date_start.getTimezoneOffset();
      _date_start = new Date(_date_start.getTime() - offset * 60 * 1000);
      _date_end = new Date(_date_end.getTime() - offset * 60 * 1000);

      // const params = await AuthService.downloadSmslog(
      //   _date_start.toISOString().split('T')[0],
      //   _date_end.toISOString().split('T')[0]
      // );

      // setReportData(params);
      setLoading(false);
    } catch (error: any) {}
  };

  return (
    <div>
      <ContentHeader title="SMS Log" />
      <section className="content">
        <div className="container-fluid">
          <Card className="card-primary">
            <Card.Header>Report Filters</Card.Header>
            <Card.Body>
              {/* <Form> */}
              <div className="row col-md-12">
                <Form.Group className="mb-3 col-md-6">
                  <Form.Label>Select Date Range</Form.Label>
                  <div className="row">
                    <div className="mb-3 col-md-6">
                      <DateTimePicker
                        pickerRef={linkedPicker1Ref}
                        format="YYYY-MM-DD"
                        extraFormats={['YYYY-MM-DD', 'YY-MM-DD']}
                        onChange={(e: any) => {
                          linkedPicker2Ref.current.datetimepicker(
                            'minDate',
                            e.date
                          );
                          setState((prevState) => ({
                            ...prevState,
                            date_start: e.date
                          }));
                        }}
                      />
                    </div>
                    <div className="mb-3 col-md-6">
                      <DateTimePicker
                        pickerRef={linkedPicker2Ref}
                        format="YYYY-MM-DD"
                        extraFormats={['YYYY-MM-DD', 'YY-MM-DD']}
                        onChange={(e: any) => {
                          linkedPicker1Ref.current.datetimepicker(
                            'maxDate',
                            e.date
                          );
                          setState((prevState) => ({
                            ...prevState,
                            date_end: e.date
                          }));
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
                <Form.Group className="mb-3 col-md-2">
                  <Form.Label>&nbsp;</Form.Label>
                  <PfButton
                    block
                    onClick={downloadReportWs}
                    loading={isLoading}
                  >
                    Submit
                  </PfButton>
                </Form.Group>
              </div>
              {/* </Form> */}
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>SMS Log</Card.Header>
            <Card.Body>
              <Table names={reportData} />
            </Card.Body>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Smslog;
